/**
 * @generated SignedSource<<3fbe258172f1e6d9079c1d34856fd35d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailCancelationPolicy_item$data = {
  readonly cancelationPolicy: {
    readonly body: string | null;
    readonly header: string | null;
    readonly linkData: {
      readonly path: string | null;
      readonly text: string | null;
    };
  } | null;
  readonly " $fragmentType": "PdpSharedDetailCancelationPolicy_item";
};
export type PdpSharedDetailCancelationPolicy_item$key = {
  readonly " $data"?: PdpSharedDetailCancelationPolicy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailCancelationPolicy_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailCancelationPolicy_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CancelationPolicy",
      "kind": "LinkedField",
      "name": "cancelationPolicy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "0027de18ccfd66cab3b89efa4cd62c3a";

export default node;
